import { initReactI18next } from 'react-i18next';
import { createI18n, type AppLocale, type AppResources } from './index';

export function initI18n(lng: AppLocale, resources: AppResources) {
  return createI18n(lng, resources, {
    modules: [initReactI18next],
    react: { useSuspense: false },
  });
}
